import { ZodError } from 'zod';
import { captureException } from '@sentry/browser';

import { apiClient } from '@f/api-client';

import { createAction } from '../actions.ts';

export const USER_DOCUMENT_SIGN_START = 'USER_DOCUMENT_SIGN_START';
export const USER_DOCUMENT_SIGN_FULFILL = 'USER_DOCUMENT_SIGN_FULFILL';
export const USER_DOCUMENT_SIGN_REJECT = 'USER_DOCUMENT_SIGN_REJECT';

export function signDocuments(documents) {
  return async dispatch => {
    // Starts
    dispatch(createAction(USER_DOCUMENT_SIGN_START));

    try {
      const result = await apiClient.documentAcceptance.signDocuments({
        body: {
          documents: documents.map(document => ({
            name: document.name,
            version: document.url,
          })),
        },
      });

      if (result.status !== 201) {
        throw new Error(result.body);
      }

      // Fulfills
      dispatch(createAction(USER_DOCUMENT_SIGN_FULFILL));
    } catch (error) {
      if (error instanceof ZodError) {
        captureException(error);
      }
      // Rejects
      dispatch(createAction(USER_DOCUMENT_SIGN_REJECT, error));
    }
  };
}
